import { DirectorySearchModule } from './../shared/directory-search/directory-search.module';
import { NgModule } from '@angular/core';
import { MessageListComponent } from './message-list/message-list.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { MessageDetailComponent } from './message-detail/message-detail.component';
import { MessageComposeComponent } from './message-compose/message-compose.component';
import { MessageReplyComponent } from './message-reply/message-reply.component';
import { CleanAddressPipe } from './clean-address.pipe';
import { DocumentModule } from '../document/document.module';
import { MessageListSectionComponent } from './message-list-section/message-list-section.component';
import { MessageListService } from '../core/service/grid-data/grid-data-message.service';

@NgModule({
  imports: [
    SharedModule,
    DocumentModule,
    DirectorySearchModule
  ],
  declarations: [
    MessageListComponent,
    MessageDetailComponent,
    MessageComposeComponent,
    MessageReplyComponent,
    CleanAddressPipe,
    MessageListSectionComponent
  ],
  exports: [
    MessageComposeComponent,
    MessageDetailComponent,
    MessageListComponent,
    CleanAddressPipe,
    MessageListSectionComponent
  ],
  providers: [
    MessageListService
  ]
})
export class MessageModule { }
